/**
 * A US-dollar amount for display — the ONE money formatter (MAR-948).
 *
 * Fixed decimals, en-US grouping: `formatUsd(1234.5)` is `$1,234.5000`. The default of four decimals
 * is the precision LLM cost has always been reported at on the admin pages; callers showing an
 * invoice-style figure pass 2, and the public research page's per-query cost passes 6. A missing or
 * non-finite amount prints as zero rather than `$NaN`. `en-US` is fixed on purpose: the currency is
 * always USD, and `es-SV` writes it the same way.
 *
 * In `shared/` because the server formats money too (the memo generator, the GPU cost report).
 * `tests/unit/formatHelpersSweep.test.ts` fails if a local copy comes back.
 */
export function formatUsd(value: number | null | undefined, fractionDigits = 4): string {
  const amount = typeof value === 'number' && Number.isFinite(value) ? value : 0
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount)
}
